<template>
  <div id="submitted">
    <form>
      <ol class="questions">
        <li>
          <fieldset>
            <legend>
              <p><i class="fa fa-check-circle"></i> Thank you for your review request.</p>
              <h2 id="submittedTitle">What happens next?</h2>
              <p>
                We have sent you an email and you will hear from us within 10
                business days regarding the review request.
              </p>
            </legend>
            <ul class="actions">
              <li>
                <em
                  ><a v-on:click="resetForm" id="return" class="button"
                    >Return to page</a
                  ></em
                >
              </li>
            </ul>
          </fieldset>
        </li>
      </ol>
    </form>
  </div>
</template>

<script>
export default {
  name: "Submitted",
  props: {
    resetEnquiry: Function,
  },
  methods: {
    resetForm: function () {
      this.$emit("resetEnquiry");
    },
  },
};
</script>
  
<style scoped lang="scss">
#submitted {
  min-height: 20em;
}
#return {
  margin-top: 3em;
  color: white !important;
  text-decoration: none !important;
}
</style>